import { Button, Modal, Spin } from "antd";
import { useCallback, useEffect } from "react";
import { EditFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllSimulation, modalActives } from "../../../../redux/slices/simulation/simulationAction";
import CardDetailProject from "../../../../components/Card/CardDetailProject";
import { FormSimulationEquivalency } from "./FormSimulationEquivalency";
import { FormProviderSimulation } from "./FormProviderSimulation";
import { FormAssetsSimulation } from "./FormAssetsSimulation";
import { CustomViewSimulation } from "./CustomViewSimulation";
import { GetSimulationContext } from "../hooks/useSimulation";
import ProviderStatusTable from "./ProviderStatusTable";
import { typeForm } from "../../../../types/forms";
import { modalsTypeSimulation } from "../services";
import TableEstimated from "./TableEstimated";
import TableProjects from "./TableProjects";
import ProviderTable from "./ProviderTable";
import AssetTable from "./AssetTable";


const Principal = ({ projectName, clickupSpace }) => {
    const dispatch = useDispatch();

    const { project, updateClickupSpace, updateProject, isLoading } = GetSimulationContext();

    const {
        auth: { isSuperAdmin },
        simulation: {
            modals: { equivalency: openModalEquivalency, assets: openAssets, provider: openProvider },
        },
    } = useSelector((state) => state);

    const getDataProjection = useCallback(() => {
        dispatch(getAllSimulation(clickupSpace));
    }, [clickupSpace, dispatch]);

    useEffect(() => {
        updateClickupSpace(clickupSpace);
    }, [clickupSpace, updateClickupSpace]);

    useEffect(() => {
        getDataProjection();
    }, [getDataProjection]);

    useEffect(() => {
        updateProject();
    }, [updateProject]);

    if (isLoading) {
        return (
            <div className="w-full h-[calc(100vh-64px)] flex justify-center items-center">
                <Spin size="large" />
            </div>
        );
    }


    return (
        <div className="lg:p-12 p-4 w-full min-h-[calc(100vh-64px)]">
            <CustomViewSimulation error={false} loading={isLoading} name={projectName}>
                <div
                    className={`flex items-start md:items-center gap-6 ${isSuperAdmin ? "justify-center flex-col md:flex-row" : "md:justify-start"}`}
                >
                    <h2 className="font-bold text-xl md:text-nowrap">{projectName}</h2>
                    {isSuperAdmin && (
                        <>
                            <div className="h-[1px] bg-lowGray w-full hidden md:block"></div>
                            <Button
                                className="bg-primaryTwo  flex justify-center items-center gap-1 h-10 w-full md:w-60"
                                type="primary"
                                onClick={() => {
                                    dispatch(modalActives(modalsTypeSimulation.equivalency, true));
                                }}
                            >
                                <EditFilled className="text-white text-base pb-1" />
                                Editar horas de equivalencia
                            </Button>
                        </>
                    )}
                </div>
                <CardDetailProject title="Simulación de cotización">
                    <div className="w-full flex flex-col md:flex-row gap-4 md:pr-4">
                        <TableEstimated calculatedHours={project?.calculatedHours} isLoading={isLoading} />
                        <TableProjects
                            isLoading={isLoading}
                            timeAreas={project?.timeAreas}
                            projection={project?.timeProjectionAreas}
                            simulationAsset={project?.assetsimulations.elements}
                            simulationProvider={project?.providerSimulations.elements}
                            calculatedTime={project?.calculatedHours}
                            equivalencyExtraResource={project?.equivalencyExtraResource}
                        />
                    </div>
                </CardDetailProject>
                <CardDetailProject titleClass="mb-0 h-0">
                    <AssetTable
                        isLoading={isLoading}
                        assetEquivalency={project?.equivalencyExtraResource.assets}
                        assets={project?.assetsimulations.allElements}
                    />
                </CardDetailProject>
                <CardDetailProject titleClass="mb-0 h-0">
                    <ProviderTable
                        isLoading={isLoading}
                        providerList={project?.providerSimulations.allElements}
                        providerEquivalency={project?.equivalencyExtraResource.providers}
                    />
                </CardDetailProject>
                <CardDetailProject title="Calculadora de Proveedores">
                    <ProviderStatusTable
                        isLoading={isLoading}
                        providerSimulations={project?.providerSimulations.allElements}
                        providerEquivalency={project?.equivalencyExtraResource.providers}
                    />
                </CardDetailProject>
            </CustomViewSimulation>
            <Modal
                title="Editar horas de equivalencia"
                placement="right"
                width={500}
                onCancel={() => dispatch(modalActives(modalsTypeSimulation.equivalency, false))}
                open={openModalEquivalency}
                footer={[]}
            >
                <FormSimulationEquivalency type={typeForm.edit} updateProject={updateProject} />
            </Modal>
            <Modal
                title="Assests"
                placement="right"
                width={500}
                onCancel={() => dispatch(modalActives(modalsTypeSimulation.assets, false))}
                open={openAssets}
                footer={[]}
            >
                <FormAssetsSimulation updateProject={updateProject} />
            </Modal>
            <Modal
                title="Proveedores"
                placement="right"
                width={500}
                onCancel={() => dispatch(modalActives(modalsTypeSimulation.provider, false))}
                open={openProvider}
                footer={[]}
            >
                <FormProviderSimulation updateProject={updateProject} />
            </Modal>
        </div >
    );
};

export default Principal;
